var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOcupacionais(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "current"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 18.7997V17.9997H8.40761L8.39961 21.1997C8.39961 22.0877 9.11161 22.7997 9.99961 22.7997H21.1996C22.0876 22.7997 22.7996 22.0877 22.7996 21.1997V17.9997H17.1996V18.7997H13.9996ZM21.9996 11.5997H18.7916V9.99966L17.1916 8.39966H13.9916L12.3916 9.99966V11.5997H9.19961C8.31961 11.5997 7.59961 12.3197 7.59961 13.1997V15.5997C7.59961 16.4877 8.31161 17.1997 9.19961 17.1997H13.9996V15.5997H17.1996V17.1997H21.9996C22.8796 17.1997 23.5996 16.4797 23.5996 15.5997V13.1997C23.5996 12.3197 22.8796 11.5997 21.9996 11.5997ZM17.1996 11.5997H13.9996V9.99966H17.1996V11.5997Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(6.3999 6.40002)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcupacionais);
export default __webpack_public_path__ + "static/media/ocupacionais.1bbab10c.svg";
export { ForwardRef as ReactComponent };